import React, { useEffect, useRef, useState } from "react";
import { COLUMNTITLES } from "../../../utils/Enum";
import api from "../../../api/api";
import Indices from "../Indices";
import CategoryIndices from "../../../interfaces/CategoryIndices";

const ArchiveHumanRightsIndices = () => {
  const [archiveHumanRightsIndicesArray, setArchiveHumanRightsIndicesArray] =
    useState<CategoryIndices | any>([]);
  const [humanIndicesVisible, setHumanndicesVisible] = useState<number[]>([]);
  const didArchiveHumanRightsGotCalled = useRef(false);
  const archiveHumanRightsIndices = async () => {
    const archiveHumanRightsIndicesResults = await api.get(
      `/archived-indices/humanrights`,
    );
    setArchiveHumanRightsIndicesArray(
      archiveHumanRightsIndicesResults.data.responseObject,
    );
    sessionStorage.setItem(
      "archiveHumanRightsIndices",
      JSON.stringify(archiveHumanRightsIndicesResults.data.responseObject),
    );
  };
  useEffect(() => {
    const storedArchivedHumanRightsIndices = sessionStorage.getItem(
      "archiveHumanRightsIndices",
    );
    if (storedArchivedHumanRightsIndices) {
      setArchiveHumanRightsIndicesArray(
        JSON.parse(storedArchivedHumanRightsIndices),
      );
    }
    if (!didArchiveHumanRightsGotCalled.current) {
      archiveHumanRightsIndices();
      didArchiveHumanRightsGotCalled.current = true;
    }
  }, []);
  const handleArrowClick = (year: number) => {
    setHumanndicesVisible((prev: any) =>
      prev.includes(year)
        ? prev.filter((currentYear: any) => currentYear !== year)
        : [...prev, year],
    );
  };
  return (
    <>
      {archiveHumanRightsIndicesArray.map((indices: any, index: number) => (
        <div key={index}>
          <div
            key={index}
            className="flex text-[24px] font-medium not-italic ml-[50px] m-[24px] space-x-1"
          >
            {indices.year}
            <button
              className="mx-[16px] p-[8px]"
              onClick={() => handleArrowClick(indices.year)}
              id="arrow-up-button"
            >
              <div
                className={`${humanIndicesVisible.includes(indices.year) ? "icon-keyboard_arrow_up" : "icon-keyboard_arrow_down"} text-2xl text-blue-600`}
              />
            </button>
          </div>
          {humanIndicesVisible.includes(indices.year) && (
            <div>
              <Indices
                key={indices.year}
                categoryTab={COLUMNTITLES.ARCHIVED}
                risksScoreIndices={indices.indices}
              />
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default ArchiveHumanRightsIndices;
